import React from "react";
import ring from "../../assets/images/banner/ring.jpg";
import set from "../../assets/images/banner/set.jpg";
import earring from "../../assets/images/banner/earring.jpg";
import earringw from "../../assets/images/banner/earringw.jpg";
import pendent from "../../assets/images/banner/pendent.jpg";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from 'react-intersection-observer';

const FeatureSection = () => {

    return (
        <section class="collections container" id="collections">
            <div class="section-header mb-5">
                <span class="section-tag">Our Collections</span>
                <h2>Pieces That Endure</h2>
                <p>Timeless designs for every milestone.</p>
            </div>
            <div class="collections__grid">
                <div class="collection-card collection-card--large">
                    <div class="collection-card__img" style={{ background: "linear-gradient(135deg, #c9a96e 0%, #f0e0c0 50%, #c9a96e 100%" }}>
                        <div class="gem-icon"><img src={ring} /></div>
                    </div>
                    <div class="collection-card__body">
                        <span class="collection-card__tag">Bestseller</span>
                        <h3>Engagement Rings</h3>
                        <p>Symbol of forever, shaped by hand.</p>
                        <Link
                            to={`${config.appUrl}contact-us`}
                            className="card-link"
                        >Discover →</Link>
                    </div>
                </div>
                <div class="collection-card">
                    <div class="collection-card__img" style={{ background: "linear-gradient(135deg, #8eb8d4 0%, #d4eaf5 50%, #8eb8d4 100%" }}>
                        <div class="gem-icon"><img src={set} /></div>
                    </div>
                    <div class="collection-card__body">
                        <h3>Necklaces</h3>
                        <p>Elegance worn close to the heart.</p>
                        {/* <a href="contact.html" class="card-link">Discover →</a> */}
                         <Link
                            to={`${config.appUrl}contact-us`}
                            className="card-link"
                        >Discover →</Link>
                    </div>
                </div>
                <div class="collection-card">
                    <div class="collection-card__img" style={{ background: "linear-gradient(135deg, #b8a0d4 0%, #e8d8f5 50%, #b8a0d4 100%" }}>
                        <div class="gem-icon"><img src={earring} /></div>
                    </div>
                    <div class="collection-card__body">
                        <h3>Earrings</h3>
                        <p>From classic studs to statement drops.</p>
                        {/* <a href="contact.html" class="card-link">Discover →</a> */}
                         <Link
                            to={`${config.appUrl}contact-us`}
                            className="card-link"
                        >Discover →</Link>
                    </div>
                </div>
                <div class="collection-card">
                    <div class="collection-card__img" style={{ background: "linear-gradient(135deg, #d4a0a0 0%, #f5d8d8 50%, #d4a0a0 100%" }}>
                        <div class="gem-icon"><img src={earringw} /></div>
                    </div>
                    <div class="collection-card__body">
                        <h3>Bracelets</h3>
                        <p>Stacks, bangles, and tennis chains.</p>
                        {/* <a href="contact.html" class="card-link">Discover →</a> */}
                         <Link
                            to={`${config.appUrl}contact-us`}
                            className="card-link"
                        >Discover →</Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
